module.exports={
  "meterSelector": {
    "apiQuery": [
      "flowType"
    ],
    "question": "What are you measuring?",
    "totalSteps": 9,
    "filterName": "Flow type",
    "stepId": "01.0",
    "button": [
      {
        "label": "Water",
        "value": "Water",
        "icon": "water",
        "totalPages": 10
      },
      {
        "label": "Oil",
        "value": "Oil",
        "icon": "oil"
      },
      {
        "label": "Steam",
        "value": "Steam",
        "icon": "steam",
        "totalPages": 10
      },
      {
        "label": "Air / Gas",
        "value": "Air / Gas",
        "icon": "air-gas"
      },
      {
        "label": "Other liquid",
        "value": "Other liquid",
        "icon": "other",
        "selectedLabel": "Based on your selection, we recommend you <a title=\"Connect with a product expert\" href=\"/meter-selector/#meterselector\">connect with a product expert</a> for assistance finding the appropriate meter options for your application.",
        "totalPages": 10
      }
    ],
    "searchResults": {
      "Results": [
        {
          "productImageUrl": "https://badgermeter.widen.net/content/9ffrt62foa/jpeg/Air%20and%20Compressed%20Gas%20Meters%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
          "brandImageUrl": "https://badgermeter.widen.net/content/yhf0kktfsd/png/Hedland-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "Air and Compressed Gas Meter",
          "url": "/products/meters/variable-area-flow-meters/air-and-compressed-gas-meter/",
          "id": "94",
          "stats": [
            {
              "label": "<p>Size</p>",
              "valueImperial": "1/4...3 in.",
              "valueMetric": "6...80 mm"
            },
            {
              "label": "<p>Temperature Range</p>",
              "valueImperial": "-20...240 °F",
              "valueMetric": "-29...116 °C"
            },
            {
              "label": "<p>Flow Range</p>",
              "valueImperial": "0.5...2200 scfm",
              "valueMetric": "0.2...1130 l/sec"
            },
            {
              "label": "<p>Pressure Range</p>",
              "valueImperial": "Up to 1500 PSI",
              "valueMetric": "Up to 103 bar"
            }
          ],
          "markets": [
            "Automotive Fluid Dispensing",
            "Aviation & Aerospace",
            "Municipal Water Treatment & Distribution",
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical",
            "Test Equipment & Services"
          ],
          "productCategory": "Meters",
          "productType": "Variable Area Flow Meters",
          "brand": "Hedland",
          "flowTypes": [
            "Air / Gas"
          ],
          "guid": "ca331136-ff6e-43c1-b513-d209a455e138"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/ly4uvs42he/jpeg/Air-Caustic%20and%20Corrosive%20Gas%20Meters%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
          "brandImageUrl": "https://badgermeter.widen.net/content/yhf0kktfsd/png/Hedland-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "Caustic and Corrosive Air/Gas Meter",
          "url": "/products/meters/variable-area-flow-meters/caustic-and-corrosive-airgas-meter/",
          "id": "96",
          "stats": [
            {
              "label": "Size Range",
              "valueImperial": "1/4…1 1/2 in.",
              "valueMetric": "6...40 mm"
            },
            {
              "label": "Temperature Range",
              "valueImperial": " -20...240 °F",
              "valueMetric": "-29…116 °C"
            },
            {
              "label": "Flow Range",
              "valueImperial": "2...800 scfm",
              "valueMetric": "1…350 lpm"
            },
            {
              "label": "Accuracy",
              "valueImperial": "±2% (1/4 in. is +7%)",
              "valueMetric": "±2% (1/4 in. is +7%)"
            }
          ],
          "markets": [
            "Automotive Fluid Dispensing",
            "Aviation & Aerospace",
            "Municipal Water Treatment & Distribution",
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical",
            "Test Equipment & Services"
          ],
          "productCategory": "Meters",
          "productType": "Variable Area Flow Meters",
          "brand": "Hedland",
          "flowTypes": [
            "Air / Gas"
          ],
          "guid": "34907486-2783-4301-bbe8-d254e02e197b"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/5lrawuyqnd/jpeg/COIN-FF%20%28low%20res%29.png?w=400&h=400&position=c&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/zzheljuso0/png/Preso-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "COIN FF",
          "url": "/products/meters/differential-pressure-flow-meters/coin-wedge-flange-process-by-flange-instrumentation-model-ff-flow-meter/",
          "id": "139",
          "stats": [
            {
              "label": "Size",
              "valueImperial": "1/2...48 in.",
              "valueMetric": "12...1219 mm"
            },
            {
              "label": "Temperature Range",
              "valueImperial": "Up to 1500 °F",
              "valueMetric": "Up to 815 °C"
            },
            {
              "label": "Pressure Range",
              "valueImperial": "Dependent on flange rating",
              "valueMetric": "Dependent on flange rating"
            },
            {
              "label": "Accuracy",
              "valueImperial": "(uncalibrated) ±3% (calibrated) ±0.5%",
              "valueMetric": "(uncalibrated) ±3% (calibrated) ±0.5%"
            }
          ],
          "markets": [
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical"
          ],
          "productCategory": "Meters",
          "productType": "Differential Pressure Flow Meters",
          "brand": "Preso",
          "flowTypes": [
            "Oil",
            "Steam",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "57869087-8c87-46e4-b962-c0a43247632d"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/s8iymbnqc3/jpeg/COIN-NB-%28with-weld%29%20%28low%20res%29.png?w=400&h=400&position=c&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/zzheljuso0/png/Preso-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "COIN NB",
          "url": "/products/meters/differential-pressure-flow-meters/coin-butt-weld-wedge-model-nb-flow-meter/",
          "id": "137",
          "stats": [
            {
              "label": "Size",
              "valueImperial": "1/2...4 in.",
              "valueMetric": "12...101 mm"
            },
            {
              "label": "Temperature Range",
              "valueImperial": "Up to 800 °F",
              "valueMetric": "Up to 426 °C"
            },
            {
              "label": "Pressure Range",
              "valueImperial": "Dependent on flange rating",
              "valueMetric": "Dependent on flange rating"
            },
            {
              "label": "Accuracy",
              "valueImperial": "(uncalibrated) ±3% (calibrated) ±0.5%",
              "valueMetric": "(uncalibrated) ±3% (calibrated) ±0.5%"
            }
          ],
          "markets": [
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical"
          ],
          "productCategory": "Meters",
          "productType": "Differential Pressure Flow Meters",
          "brand": "Preso",
          "flowTypes": [
            "Oil",
            "Steam",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "31fdfe6b-d040-401a-ad0b-4e64e0016016"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/m8verp5tni/jpeg/COIN-NF%20%28low%20res%29.png?w=400&h=400&position=c&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/zzheljuso0/png/Preso-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "COIN NF",
          "url": "/products/meters/differential-pressure-flow-meters/coin-flanged-with-npt-pressure-taps-model-nf-flow-meter/",
          "id": "138",
          "stats": [
            {
              "label": "Size",
              "valueImperial": "1/2...48 in.",
              "valueMetric": "12...1,219 mm"
            },
            {
              "label": "Accuracy",
              "valueImperial": "(uncalibrated) ±3% (calibrated) ±0.5%",
              "valueMetric": "(uncalibrated) ±3% (calibrated) ±0.5%"
            }
          ],
          "markets": [
            "Process & General Industry"
          ],
          "productCategory": "Meters",
          "productType": "Differential Pressure Flow Meters",
          "brand": "Preso",
          "flowTypes": [
            "Oil",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "dcb7bd65-a1fa-4309-bb4d-697274a1623a"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/3niwaz7vpr/jpeg/NN%20Back-to-Back-Wedge-Meter%20%28low%20res%29.png?w=400&h=400&position=c&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/zzheljuso0/png/Preso-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "COIN NN",
          "url": "/products/meters/differential-pressure-flow-meters/coin-back-to-back-wedge-model-nn-flow-meter/",
          "id": "136",
          "stats": [
            {
              "label": "Size",
              "valueImperial": "1/2...6 in.",
              "valueMetric": "12...152 mm"
            },
            {
              "label": "Temperature Range",
              "valueImperial": "Up to 800 °F",
              "valueMetric": "Up to 426 °C"
            },
            {
              "label": "Pressure Range",
              "valueImperial": "Dependent on flange rating",
              "valueMetric": "Dependent on flange rating"
            },
            {
              "label": "Accuracy",
              "valueImperial": "(uncalibrated) ±3% (calibrated) ±0.5%",
              "valueMetric": "(uncalibrated) ±3% (calibrated) ±0.5%"
            }
          ],
          "markets": [
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical"
          ],
          "productCategory": "Meters",
          "productType": "Differential Pressure Flow Meters",
          "brand": "Preso",
          "flowTypes": [
            "Oil",
            "Steam",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "2acc193c-dad7-45e2-b2da-d66715c99b6d"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/qi7m5tqc94/jpeg/COIN-NW%20%28low%20res%29.png?w=400&h=400&position=c&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/zzheljuso0/png/Preso-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "Coin NW",
          "url": "/products/meters/differential-pressure-flow-meters/coin-wedge-wafer-model-nw-flow-meter/",
          "id": "135",
          "stats": [
            {
              "label": "Size",
              "valueImperial": "1/2...4 in.",
              "valueMetric": "13...101 mm"
            },
            {
              "label": "Temperature Range",
              "valueImperial": "Up to 800 °F",
              "valueMetric": "Up to 426 °C"
            },
            {
              "label": "Pressure Rating",
              "valueImperial": "Dependent on flange rating ",
              "valueMetric": "Dependent on flange rating"
            },
            {
              "label": "Accuracy",
              "valueImperial": "(uncalibrated) ±3% (calibrated) ±0.5%",
              "valueMetric": "(uncalibrated) ±3% (calibrated) ±0.5%"
            }
          ],
          "markets": [
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical"
          ],
          "productCategory": "Meters",
          "productType": "Differential Pressure Flow Meters",
          "brand": "Preso",
          "flowTypes": [
            "Oil",
            "Steam",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "d7a7121d-391a-4f4c-80f8-d682bf7669d8"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/pyfbogfk4l/jpeg/2019_Cone%20Meter%20%28low%20res%29.png?w=400&h=400&position=c&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/zzheljuso0/png/Preso-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "Cone DP Meters",
          "url": "/products/meters/differential-pressure-flow-meters/cone-differential-pressure-flow-meter/",
          "id": "140",
          "stats": [
            {
              "label": "Size",
              "valueImperial": "1/2...24 in.",
              "valueMetric": "12...609 mm"
            },
            {
              "label": "Accuracy",
              "valueImperial": "±0.5%",
              "valueMetric": "±0.5%"
            }
          ],
          "markets": [
            "Aviation & Aerospace",
            "Building Design, HVAC, & Plumbing",
            "Municipal Water Treatment & Distribution",
            "Oil & Gas",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical",
            "Test Equipment & Services"
          ],
          "productCategory": "Meters",
          "productType": "Differential Pressure Flow Meters",
          "brand": "Preso",
          "flowTypes": [
            "Oil",
            "Steam",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "d3bcb2a8-dab3-459d-8be6-b7c7489d6298"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/sabwvp2yss/jpeg/Cox%20Gas%20Turbine%20Meters%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
          "brandImageUrl": "https://badgermeter.widen.net/content/i3c0moz15i/png/Cox-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "CPG - Precision Meter for Gases",
          "url": "/products/meters/turbine-flow-meters/precision-gas-flow-meter/",
          "id": "148",
          "stats": [
            {
              "label": "Size Range",
              "valueImperial": "0.25...2 in. ",
              "valueMetric": "6...50 mm"
            },
            {
              "label": "Flow Range",
              "valueImperial": "0.4...250 scfm",
              "valueMetric": "1.89...118 lps"
            },
            {
              "label": "Pressure Range",
              "valueImperial": "Up to 5000 PSI",
              "valueMetric": "Up to 344 bar"
            },
            {
              "label": "Temperature Range",
              "valueImperial": "Up to 500 °F",
              "valueMetric": "Up to 260 °C"
            }
          ],
          "markets": [
            "Aviation & Aerospace",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical",
            "Test Equipment & Services"
          ],
          "productCategory": "Meters",
          "productType": "Turbine Flow Meters",
          "brand": "Cox",
          "flowTypes": [
            "Air / Gas"
          ],
          "guid": "ce0c3b13-f870-4112-baba-a86e1fc064c0"
        },
        {
          "productImageUrl": "https://badgermeter.widen.net/content/ylw0ld9kol/jpeg/Cox%20Precision%20Turbine%20Meters%20%28low-res%29.png?w=600&h=600&keep=c&crop=yes&color=ffffffff&quality=80&u=rf1shk",
          "brandImageUrl": "https://badgermeter.widen.net/content/i3c0moz15i/png/Cox-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
          "productName": "CPT - Precision Single Rotor",
          "url": "/products/meters/turbine-flow-meters/precision-turbine-meter/",
          "id": "146",
          "stats": [
            {
              "label": "Size Range",
              "valueImperial": "0.25...2 in.",
              "valueMetric": "6...50 mm"
            },
            {
              "label": "Flow Range",
              "valueImperial": "0.05...310 gpm",
              "valueMetric": "0.19...1173 l/min"
            },
            {
              "label": "Pressure Range",
              "valueImperial": "Up to 6000 PSI",
              "valueMetric": "Up to 408 bar"
            },
            {
              "label": "Temperature Range",
              "valueImperial": "Up to 450 °F ",
              "valueMetric": "Up to 232 °C"
            }
          ],
          "markets": [
            "Aviation & Aerospace",
            "Process & General Industry",
            "Refining, Chemical & Petrochemical",
            "Test Equipment & Services"
          ],
          "productCategory": "Meters",
          "productType": "Turbine Flow Meters",
          "brand": "Cox",
          "flowTypes": [
            "Oil",
            "Air / Gas",
            "Water",
            "Other liquid"
          ],
          "guid": "f9efd9cf-2b00-4661-97ac-2c6eba04a994"
        }
      ],
      "SavedItemsCount": 0,
      "TotalResults": 7,
      "ViewProductLabel": "view product label"
    }
  },
  "searchResults": {
    "results": [
      {
        "title": "M2000 Electromagnetic Flow Meter",
        "description": "<p>Combining a general-purpose detector with an amplifier, the ModMAG<sup>&reg;</sup> M2000 Electromagnetic flow meter features an advanced, user-friendly design that is built for field verification testing with the use of a simple, handheld device.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/97vunv3vsv/jpeg/ModMAG-M2000-%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/electromagnetic-flow-meters/m2000-electromagnetic-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_1666a162-2dfd-44d7-9f34-9b39f090b223_en"
      },
      {
        "title": "M5000 Electromagnetic Flow Meter",
        "description": "<p>The ModMAG<sup>&reg;</sup> M5000 Electromagnetic flow meter is an ideal solution for remote potable water applications, providing consistently reliable and accurate measurements.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/9yihjbuepv/jpeg/ModMAG-M5000-%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=hdkpxq",
        "linkUrl": "/products/meters/electromagnetic-flow-meters/m5000-electromagnetic-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_bfb42605-a11a-4c92-a58e-812d05527d28_en"
      },
      {
        "title": "<p>U500w Ultrasonic Flow Meter</p>",
        "description": "<p>The Dynasonics<sup>&reg;</sup> U500w Ultrasonic flow meter uses solid-state technology in a compact, completely encapsulated housing, suitable for residential and commercial applications.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/nthehsoabl/jpeg/U500w%20Ultrasonic%20Flow%20Meters%20%28low%20res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=hdkpxq",
        "linkUrl": "/products/meters/ultrasonic-flow-meters/u500w-ultrasonic-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_2eaf6ba9-9340-4f02-a5bf-27e0dab4bcf2_en"
      },
      {
        "title": "DXN Portable Hybrid Ultrasonic Flow Meter",
        "description": "<p>The Dynasonics<sup>&reg;</sup> DXN Portable Hybrid Ultrasonic flow meter is a powerful tool used for troubleshooting flow issues, whether you want to quickly verify the flow reading of another meter or to data log flow system values over an extended period of time.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/1uye50izbz/jpeg/Hybrid%20Ultrasonic%20Flow%20Meters%20-%20DXN%20%28low%20res%29.png?w=600&h=600&keep=c&crop=yes&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/ultrasonic-flow-meters/dxn-portable-hybrid-ultrasonic-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_54b3483b-33c5-4106-a12b-a530af8f53c6_en"
      },
      {
        "title": "380 Series BTU System Meter",
        "description": "<p>The Series 380 BTU meter is an all-in-one energy usage package for monitoring hydronic heating or cooling systems. This meter accurately measures flow and temperature differential to compute energy and can interface with many existing control systems.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/sbtdpgcxvd/jpeg/380%20Series%20Btu%20System%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/impeller-flow-products/380-series-btu-system-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_9d08a29f-c6a7-4783-9a85-774b369dc89d_en"
      },
      {
        "title": "<p>Precision Turbine Meter</p>",
        "description": "<p>The Cox<sup>&reg;</sup> Precision Turbine Meter has unprecedented mechanical linearity, resulting in minimizing or negating temperature induced viscosity influence.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/ylw0ld9kol/jpeg/Cox%20Precision%20Turbine%20Meters%20%28low-res%29.png?w=600&h=600&keep=c&crop=yes&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/turbine-flow-meters/precision-turbine-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_f9efd9cf-2b00-4661-97ac-2c6eba04a994_en"
      },
      {
        "title": "B1750 Positive Displacement Meter",
        "description": "<p>The Blancett<sup>&reg;</sup> B1750 Positive Displacement meter provides high measurement accuracy for fluids over a wide viscosity range.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/idv3exmbrj/jpeg/Positive%20Displacement%20-%20B1750%20%28low-res%29.png?w=600&h=600&keep=c&crop=yes&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/turbine-flow-meters/b1750-positive-displacement-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_398b68a9-53aa-4f60-8dad-889c47644324_en"
      },
      {
        "title": "B1500 Turbine Flow Meter",
        "description": "<p>The Blancett<sup>&reg;</sup> B1500 Turbine flow meter has exceptional mechanical linearity, resulting in minimizing or negating temperature induced viscosity influence.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/vevizb2zpc/jpeg/B1500%20with%20Monitor%20%28low%20res%29.png?w=600&h=600&keep=c&crop=yes&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/turbine-flow-meters/b1500-turbine-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_1392645a-e6db-4afe-a83a-7e2ab8d95658_en"
      },
      {
        "title": "900 Series Flow Meter",
        "description": "<p>The Blancett<sup>&reg;</sup> 900 Series flow meter is rugged, low-priced and specifically designed to measure floodwater line flow in secondary oil recovery operations.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/wbnbckchqu/jpeg/900%20Series%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
        "linkUrl": "/products/meters/turbine-flow-meters/900-series-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_3d399e3a-2e98-484e-8e71-3bdff24bb65d_en"
      },
      {
        "title": "Phosphate Ester Fluid Meter",
        "description": "<p>The Hedland<sup>&reg;</sup> phosphate ester fluid meter provides a measurement solution for fire-resistant fluids, aviation hydraulic fluid and industrial lubricant, which have high ignition temperatures and low vapor pressures.</p>\n<p><a title=\"Download a Hedland Price List\" href=\"/link/ca09b26a040544e1b7426c795cc22707.aspx\" target=\"_blank\" rel=\"noopener\"><em>Download a Hedland Price List</em></a></p>",
        "imageUrl": "https://badgermeter.widen.net/content/7keut3aify/jpeg/Phosphate%20Ester%20Fluid%20Meter%20%28low%20res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
        "linkUrl": "/products/meters/variable-area-flow-meters/phosphate-ester-fluid-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_82285c14-14b7-4e65-9848-3c67c6a1c1e8_en"
      }
    ],
    "savedItemsCount": 0,
    "totalResults": 1542,
    "trackId": "JXkJYrdtqhkFNyCtCrBnPw==",
    "filterCountResults": [
      {
        "filterValue": 59,
        "count": 196
      },
      {
        "filterValue": 56,
        "count": 24
      },
      {
        "filterValue": 159,
        "count": 9
      },
      {
        "filterValue": 60,
        "count": 10
      },
      {
        "filterValue": 36,
        "count": 7
      },
      {
        "filterValue": 222,
        "count": 10
      },
      {
        "filterValue": 205,
        "count": 9
      },
      {
        "filterValue": 65,
        "count": 23
      },
      {
        "filterValue": 64,
        "count": 19
      },
      {
        "filterValue": 35,
        "count": 1078
      },
      {
        "filterValue": 161,
        "count": 11
      },
      {
        "filterValue": 157,
        "count": 57
      },
      {
        "filterValue": 158,
        "count": 21
      },
      {
        "filterValue": 201,
        "count": 47
      },
      {
        "filterValue": 58,
        "count": 14
      },
      {
        "filterValue": 160,
        "count": 7
      }
    ],
    "didYouMean": [
      "meter specification",
      "strainer",
      "pulse meter",
      "meters",
      "meter "
    ]
  },
  "searchResults2": {
    "results": [
      {
        "title": "Specifications / ModMAG",
        "description": "ModMAG® M3000",
        "imageUrl": "/static/images/doc-icon.svg",
        "linkUrl": "https://badgermeter.widen.net/content/0ytwh51ram/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_c635b182-867d-46ab-bba6-cfa4e82b3e49_en"
      },
      {
        "title": "M2000 Electromagnetic Flow Meter",
        "description": "<p>Combining a general-purpose detector with an amplifier, the ModMAG<sup>&reg;</sup> M2000 Electromagnetic flow meter features an advanced, user-friendly design that is built for field verification testing with the use of a simple, handheld device.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/97vunv3vsv/jpeg/ModMAG-M2000-%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rf1shk",
        "linkUrl": "/products/meters/electromagnetic-flow-meters/m2000-electromagnetic-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "isProduct": true,
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_1666a162-2dfd-44d7-9f34-9b39f090b223_en"
      },
      {
        "title": "Product Data Sheets / ModMAG",
        "description": "M-Series® M4000",
        "imageUrl": "/static/images/pdf-icon.svg",
        "linkUrl": "https://badgermeter.widen.net/content/iiiwrqlyde/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "isProduct": false,
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_947c8940-b704-431a-9cb1-abe18f873fe4_en"
      },
      {
        "title": "Brochures / AquaCUE, Dynasonics, Impeller, Industrial Oval Gear (IOG), ModMAG, Recordall, Vortex",
        "description": "ModMAG® M4000",
        "imageUrl": "",
        "linkUrl": "https://badgermeter.widen.net/content/pnuoqyhk3f/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_f7d86f38-8c5d-436f-bcf4-1fe5ca5d2a23_en"
      },
      {
        "title": "<p>How Modern Technology and Data Analytics Are Enabling Total Visibility of Water Use</p>",
        "description": "ModMAG® M1000, M2000 and M5000 Field Verification Device Manual",
        "imageUrl": "",
        "linkUrl": "https://badgermeter.widen.net/content/gv55za7hzw/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_b47c6583-b31d-44e4-bbfb-e59c90642806_en"
      },
      {
        "title": "<p>Badger Meter Improves Operating Reliability in Hydronic Heating and Cooling Applications</p>",
        "description": "ModMAG® M5000 OIML Certificate of Conformity",
        "imageUrl": "",
        "linkUrl": "https://badgermeter.widen.net/content/1y8oj0khwe/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_17a270e2-433d-4490-b492-ca7af876c6f6_en"
      },
      {
        "title": "M5000 Electromagnetic Flow Meter",
        "description": "<p>The ModMAG<sup>&reg;</sup> M5000 Electromagnetic flow meter is an ideal solution for remote potable water applications, providing consistently reliable and accurate measurements.</p>",
        "imageUrl": "https://badgermeter.widen.net/content/9yihjbuepv/jpeg/ModMAG-M5000-%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=hdkpxq",
        "linkUrl": "/products/meters/electromagnetic-flow-meters/m5000-electromagnetic-flow-meter/",
        "filterValue": 59,
        "filterText": "Products",
        "isProduct": true,
        "hitId": "BadgerMeter_Web_Models_Catalog_ProductVariation/CatalogContent_bfb42605-a11a-4c92-a58e-812d05527d28_en"
      },
      {
        "title": "Specifications / ModMAG",
        "description": "ModMAG® M7600 Electromagnetic Flow Meter",
        "imageUrl": "",
        "linkUrl": "https://badgermeter.widen.net/content/1fdwgy8ecr/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_adc43f32-036f-43bc-aa46-3a57116ef114_en"
      },
      {
        "title": "Specifications / ModMAG",
        "description": "ModMAG® M1000",
        "imageUrl": "",
        "linkUrl": "https://badgermeter.widen.net/content/rayfx51aak/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_9e73d507-e7cd-42c1-a5f3-d417f2d72739_en"
      },
      {
        "title": "Application Data Sheets / ModMAG",
        "description": "ModMAG® M2000 Connecting a Badger Meter Endpoint to the M2000",
        "imageUrl": "",
        "linkUrl": "https://badgermeter.widen.net/content/tmwpmjrqkx/original?download=true&x.app=api",
        "filterValue": 35,
        "filterText": "Documents",
        "hitId": "BadgerMeter_Web_Models_Blocks_DataBlocks_DAMDocumentBlock/_eaf19cc3-1275-41c2-a42c-d0d9434a8298_en"
      }
    ],
    "savedItemsCount": 0,
    "totalResults": 122,
    "trackId": "JXkJYrdtqhkFNyCtCrBnPw==",
    "filterCountResults": [
      {
        "filterValue": 56,
        "count": 1
      },
      {
        "filterValue": 35,
        "count": 97
      },
      {
        "filterValue": 59,
        "count": 7
      },
      {
        "filterValue": 36,
        "count": 3
      },
      {
        "filterValue": 64,
        "count": 2
      },
      {
        "filterValue": 161,
        "count": 1
      },
      {
        "filterValue": 157,
        "count": 9
      },
      {
        "filterValue": 158,
        "count": 2
      }
    ],
    "didYouMean": [
      "modmag m2000 manual",
      "modmag m2000",
      "modmag ",
      "modmag m"
    ]
  },
  "searchResultsNone": {
    "results": [],
    "savedItemsCount": 0,
    "totalResults": 0,
    "trackId": "1v7sJX0O1notEuJ3MpFl5w==",
    "filterCountResults": [],
    "didYouMean": [
      "meters"
    ]
  },
  "documentsById": {
    "results": [
      {
        "eyebrow": "APPLICATION DATA SHEET",
        "name": "Electromagnetic flow meter data sheet",
        "details": "ModMAG M-Series M2000",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "36"
      },
      {
        "eyebrow": "APPLICATION DATA SHEET2",
        "name": "Electromagnetic flow meter data sheet",
        "details": "ModMAG M-Series M2000",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "36"
      },
      {
        "eyebrow": "APPLICATION DATA SHEET3",
        "name": "Electromagnetic flow meter data sheet",
        "details": "ModMAG M-Series M2000",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "36"
      }
    ]
  },
  "softwareById": {
    "results": [
      {
        "eyebrow": "Dynasonics",
        "name": "<p>Dynasonics TFX Ultra - English Firmware<sup>&reg;</sup><p>",
        "details": "Firmware | Version D007-1045-018_RevT | Updated July 23, 2020 | 190 KB | <a href=\"\">See release notes</a>",
        "downloadUrl": "https://badgermeter.widen.net/content/v4yty5lduv/original/Dynasonics%20TFX%20Ultra%20-%20English%20Firmware-D007-1045-018_RevT.zip?download=true&x.app=api&expires=1595695089240&signature.version=V3&signature=aY-cU4AjThtvO94DKpSRRQrSh9ZCgOLNPxZF_zKFoPQ%3D",
        "viewDetailsUrl": "/en/test-software-page-1/",
        "id": "73"
      },
      {
        "eyebrow": "eyebrow",
        "name": "Dynasonics TFX Ultra - French Firmware2",
        "details": "Firmware | Version D007-1045-020_RevU | Updated July 23, 2020 | 190 KB | <a href=\"\">See release notes</a>",
        "downloadUrl": "https://badgermeter.widen.net/content/rrutsxzq68/original/Dynasonics%20TFX%20Ultra%20-%20French%20Firmware-D007-1045-020_RevU.zip?download=true&x.app=api&expires=1595695089240&signature.version=V3&signature=f74dbR2mLkoPvrwCrBmbJm-s899ZfXukzr3hLRJr_Lw%3D",
        "viewDetailsUrl": null,
        "id": "74"
      },
      {
        "eyebrow": "Dynasonics",
        "name": "Dynasonics TFX Ultra EtherNet-IP eds file",
        "details": "Software | Version N/A | Updated July 23, 2020 | 25 KB | <a href=\"\">See release notes</a>",
        "downloadUrl": "https://badgermeter.widen.net/content/w98jtufybu/original/Dynasonics%20TFX%20Ultra%20EtherNet-IP%20eds%20file.eds?download=true&x.app=api&expires=1595695089240&signature.version=V3&signature=gapKEGxWK38f6VfA55eWyYZRZxueLPQMR-iuzfijZsY%3D",
        "viewDetailsUrl": null,
        "id": "75"
      }
    ]
  },
  "recentPosts": {
    "success": "true",
    "page": 1,
    "count": 50,
    "prevPage": null,
    "nextPage": 3,
    "pageCount": 3,
    "totalPages": 6,
    "limit": 24,
    "results": [
      {
        "image": "https://placehold.it/353x550",
        "title": "<p>10 ways flow meters aid in water & wastewater treatment</p>",
        "url": "#",
        "type": "Article",
        "info": "2 min read"
      },
      {
        "image": "https://placehold.it/353x550",
        "title": "<b>Blancett meters</b> help hydraulic fracturing companies",
        "url": "#",
        "type": "Article",
        "info": "2 min read"
      },
      {
        "image": "https://placehold.it/353x550",
        "title": "<strong>High temperature</strong><sup>©</sup> gas control for automotive test cell",
        "url": "#",
        "type": "Article",
        "info": "2 min read"
      },
      {
        "image": "https://placehold.it/353x550",
        "title": "<span style='font-weight: 400;font-size:20px;color: red;line-height:30px;'>High temperature gas control for automotive test cell</span>",
        "url": "#",
        "type": "Article",
        "info": "2 min read"
      }
    ]
  },
  "productsByBrand": {
    "success": "true",
    "results": [
      {
        "key": "B1500 Turbine Flow Meter",
        "value": "B1500 Turbine Flow Meter"
      },
      {
        "key": "B1750 Positive Displacement Meter",
        "value": "B1750 Positive Displacement Meter"
      },
      {
        "key": "B2900 Series Flow Monitor",
        "value": "B2900 Series Flow Monitor"
      },
      {
        "key": "B3000 Series Flow Monitor",
        "value": "B3000 Series Flow Monitor"
      },
      {
        "key": "B3100 Series Flow Monitor",
        "value": "B3100 Series Flow Monitor"
      },
      {
        "key": "FloClean Sanitary Turbine Flow Meter",
        "value": "FloClean Sanitary Turbine Flow Meter"
      },
      {
        "key": "Intelligent Frequency Converter",
        "value": "<p>Intelligent Frequency Converter</p>"
      },
      {
        "key": "K-Factor Scaler (Blancett)",
        "value": "<p>K-Factor Scaler (Blancett)</p>"
      },
      {
        "key": "Model 1100 Turbine Flow Meter",
        "value": "Model 1100 Turbine Flow Meter"
      },
      {
        "key": "Model 1200 In-Line Turbine Flow Meter",
        "value": "Model 1200 In-Line Turbine Flow Meter"
      },
      {
        "key": "Model 900 Series Flow Meter",
        "value": "900 Series Flow Meter"
      },
      {
        "key": "QuikSert Gas B142",
        "value": "<p>B142 Gas QuikSert<sup>&reg;</sup> Turbine Flow Meter</p>"
      },
      {
        "key": "QuikSert In-Line Turbine Flow Meter",
        "value": "<p>QuikSert<sup>&reg;</sup> In-Line Turbine Flow Meter</p>"
      }
    ]
  },
  "products": {
    "success": "true",
    "viewProductLabel": "View product label",
    "totalResults": 10,
    "results": [
      {
        "productImageUrl": "https://badgermeter.widen.net/content/odvvjf5xo7/jpeg/10%2C000%20psi%20-%20HP-10%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
        "brandImageUrl": "https://badgermeter.widen.net/content/9pdcioduim/png/RCV-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
        "productName": "<p>10,000 PSI Type HP-10 High Pressure Control Valve</p>",
        "url": "/products/valves/10000-psi-type-hp-10-high-pressure-control-valve/",
        "id": "70",
        "stats": [
          {
            "label": "Size",
            "valueImperial": "1/4...1/2 in.",
            "valueMetric": "6...12 mm"
          },
          {
            "label": "Temperature Range",
            "valueImperial": "75…1000 °F",
            "valueMetric": "24…538 °C"
          },
          {
            "label": "Flow Range",
            "valueImperial": "0…2.5 cv",
            "valueMetric": "0...35.75 kv"
          },
          {
            "label": "Pressure Range",
            "valueImperial": "Up to 10,000 PSI",
            "valueMetric": "Up to 689 bar"
          }
        ],
        "markets": [
          "Aviation & Aerospace",
          "Oil & Gas",
          "Process & General Industry",
          "Refining, Chemical & Petrochemical",
          "Test Equipment & Services"
        ],
        "productCategory": "Valves",
        "productType": null,
        "brand": "Research Control Valves",
        "flowTypes": [
          "Oil",
          "Steam",
          "Air / Gas",
          "Water",
          "Other liquid"
        ],
        "guid": "b51983af-7c6e-44d2-850d-477bf9968dc5"
      },
      {
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG <sup>M-Series</sup> sample",
        "url": "/url/to/product",
        "id": "7",
        "brand": "brand2",
        "stats": [
          {
            "label": "Size",
            "valueMetric": "54 cm.",
            "valueImperial": "5634 in."
          },
          {
            "label": "Temperature range",
            "valueMetric": "up tp 123C",
            "valueImperial": "up tp 123F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 123 metric",
            "valueImperial": "up tp 123 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "8",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000",
        "url": "/url/to/product",
        "id": "12",
        "brand": "brand4",
        "stats": [
          {
            "label": "Size",
            "valueMetric": "1-7 cm.",
            "valueImperial": "1/4-2 in."
          },
          {
            "label": "Temperature range",
            "valueMetric": "up tp 000C",
            "valueImperial": "up tp 000F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 000 metric",
            "valueImperial": "up tp 000 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "9",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "10",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "11",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "17",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "18",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      }
    ]
  },
  "productsTest": {
    "success": "true",
    "viewProductLabel": "View product label",
    "totalResults": 10,
    "results": [
      {
        "productImageUrl": "https://badgermeter.widen.net/content/odvvjf5xo7/jpeg/10%2C000%20psi%20-%20HP-10%20%28low-res%29.png?w=600&h=600&position=c&color=ffffffff&quality=80&u=rb73pf",
        "brandImageUrl": "https://badgermeter.widen.net/content/9pdcioduim/png/RCV-Logo_Simplified_Gray%20%28Low%20Res%29.png?h=36&position=c&color=ffffff00&quality=80&u=uzmwhv",
        "productName": "<p>Test</p>",
        "url": "/products/valves/10000-psi-type-hp-10-high-pressure-control-valve/",
        "id": "4561",
        "stats": [
          {
            "label": "Size",
            "valueImperial": "1/4...1/2 in.",
            "valueMetric": "6...12 mm"
          },
          {
            "label": "Temperature Range",
            "valueImperial": "75…1000 °F",
            "valueMetric": "24…538 °C"
          },
          {
            "label": "Flow Range",
            "valueImperial": "0…2.5 cv",
            "valueMetric": "0...35.75 kv"
          },
          {
            "label": "Pressure Range",
            "valueImperial": "Up to 10,000 PSI",
            "valueMetric": "Up to 689 bar"
          }
        ],
        "markets": [
          "Aviation & Aerospace",
          "Oil & Gas",
          "Process & General Industry",
          "Refining, Chemical & Petrochemical",
          "Test Equipment & Services"
        ],
        "productCategory": "Valves",
        "productType": null,
        "brand": "Research Control Valves",
        "flowTypes": [
          "Oil",
          "Steam",
          "Air / Gas",
          "Water",
          "Other liquid"
        ],
        "guid": "b51983af-7c6e-44d2-850d-477bf9968dc5"
      },
      {
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG <sup>M-Series</sup> sample",
        "url": "/url/to/product",
        "id": "700",
        "brand": "brand2",
        "stats": [
          {
            "label": "Size",
            "valueMetric": "54 cm.",
            "valueImperial": "5634 in."
          },
          {
            "label": "Temperature range",
            "valueMetric": "up tp 123C",
            "valueImperial": "up tp 123F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 123 metric",
            "valueImperial": "up tp 123 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "test testModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "800",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000",
        "url": "/url/to/product",
        "id": "1200",
        "brand": "brand4",
        "stats": [
          {
            "label": "Size",
            "valueMetric": "1-7 cm.",
            "valueImperial": "1/4-2 in."
          },
          {
            "label": "Temperature range",
            "valueMetric": "up tp 000C",
            "valueImperial": "up tp 000F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 000 metric",
            "valueImperial": "up tp 000 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "900",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "500",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "400",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "100",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      },
      {
        "productImageUrl": "https://placehold.it/200x150",
        "brandImageUrl": "https://placehold.it/62x20",
        "productName": "ModMAG M-Series M2000 blah blah blah",
        "url": "/url/to/product",
        "id": "150",
        "brand": "brand3",
        "stats": [
          {
            "label": "Something else",
            "valueMetric": "97 cm.",
            "valueImperial": "3435 in."
          },
          {
            "label": "Something",
            "valueMetric": "up tp 765C",
            "valueImperial": "up tp 777F"
          },
          {
            "label": "Prassure range",
            "valueMetric": "up tp 777 metric",
            "valueImperial": "up tp 777 us"
          }
        ]
      }
    ]
  },
  "software": {
    "results": [
      {
        "eyebrow": "Dynasonics",
        "name": "LM_LM-OGA-OGTAER_ZUL_MID_01_2012",
        "details": "Firmware | Version D007-1045-018_RevT | Updated July 23, 2020 | 190 KB",
        "downloadUrl": "https://badgermeter.widen.net/content/v4yty5lduv/original/Dynasonics%20TFX%20Ultra%20Firmware%20%5BEnglish%5D%20-%20D007-1045-018_RevT.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": null,
        "id": "295",
        "productName": null,
        "languages": [
          "English"
        ],
        "brand": "Dynasonics",
        "brands": [
          "Dynasonics"
        ],
        "downloadType": "Firmware",
        "documentName": "Dynasonics TFX Ultra Firmware [English]",
        "releaseNotes": "test test test test test"
      },
      {
        "eyebrow": "Impeller/Data Industrial",
        "name": "Impeller 340LW Series LonWorks Configuration Software",
        "details": "Software | Updated August 19, 2020 | 1 KB",
        "downloadUrl": "https://badgermeter.widen.net/content/hlnzlwdv0t/original/Impeller%20340LW%20Series%20LonWorks%20Configuration%20Software.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/Impeller-340lw-series-lonworks-configuration-software/",
        "id": "438",
        "productName": "Type 340 LW-LonWorks BTU Transmitter",
        "languages": [
          "English"
        ],
        "brand": "Impeller/Data Industrial",
        "brands": [
          "Impeller/Data Industrial"
        ],
        "downloadType": "Software",
        "documentName": "Impeller 340LW Series LonWorks Configuration Software",
        "releaseNotes": null
      },
      {
        "eyebrow": "ModMAG",
        "name": "ModMag Field Verification Device PC Software",
        "details": "Software | Version v1.0.17 | Updated August 19, 2020 | 7.02 MB",
        "downloadUrl": "https://badgermeter.widen.net/content/zjvppiew3o/original/ModMAG%20Field%20Verification%20Device%20PC%20Software%20-%20v1.0.17.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/modmag-field-verification-device-pc-software/",
        "id": "446",
        "productName": null,
        "languages": [
          "English"
        ],
        "brand": "ModMAG",
        "brands": [
          "ModMAG"
        ],
        "downloadType": "Software",
        "documentName": "ModMag Field Verification Device PC Software",
        "releaseNotes": null
      },
      {
        "eyebrow": "Blancett",
        "name": "Blancett B3100 Monitor Configuration Software",
        "details": "Software | Updated August 19, 2020 | 1.51 MB",
        "downloadUrl": "https://badgermeter.widen.net/content/5y34yrqpp6/original/Blancett%20B3100%20Monitor%20Configuration%20Software.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/blancett-b3100-monitor-configuration-software/",
        "id": "452",
        "productName": "B3100 Series Flow Monitor",
        "languages": [
          "English"
        ],
        "brand": "Blancett",
        "brands": [
          "Blancett"
        ],
        "downloadType": "Software",
        "documentName": "Blancett B3100 Monitor Configuration Software",
        "releaseNotes": "test"
      },
      {
        "eyebrow": "Cox ; Impeller/Data Industrial",
        "name": "FC-5000 Firmware [Legacy]",
        "details": "Firmware | Version v1.2.4 | Updated August 19, 2020 | 374 KB",
        "downloadUrl": "https://badgermeter.widen.net/content/ka4jpbkvo0/original/FC-5000%20Firmware%20-%20Legacy%201.2.4.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/fc-5000-firmware-legacy/",
        "id": "436",
        "productName": "FC-5000 BTU Monitor ; FC-5000 Flow Computer ; FC-5000 Flow Display",
        "languages": [
          "English"
        ],
        "brand": "Cox, Impeller/Data Industrial",
        "brands": [
          "Cox",
          "Impeller/Data Industrial"
        ],
        "downloadType": "Firmware",
        "documentName": "FC-5000 Firmware [Legacy]",
        "releaseNotes": null
      },
      {
        "eyebrow": "Coriolis",
        "name": "Coriolls RCTX Transmitter EtherNet/IP EDS",
        "details": "Software | Updated August 19, 2020 | 3 KB",
        "downloadUrl": "https://badgermeter.widen.net/content/b3csju1yft/original/Coriolls%20EtherNetIP%20eds%20file%20for%20RCTX%20transmitter.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/coriolis-ethernet-ip-eds-file-for-rctx-transmitter/",
        "id": "450",
        "productName": null,
        "languages": [
          "English"
        ],
        "brand": "Coriolis",
        "brands": [
          "Coriolis"
        ],
        "downloadType": "Software",
        "documentName": "Coriolls RCTX Transmitter EtherNet/IP EDS",
        "releaseNotes": null
      },
      {
        "eyebrow": "Dynasonics",
        "name": "Dynaconics Flow Meter Tool",
        "details": "Software | Version v1.6.10 | Updated August 19, 2020 | 2.24 MB",
        "downloadUrl": "https://badgermeter.widen.net/content/p2nz5p5ylj/original/Dynaconics%20Flow%20Meter%20Tool%20-%20v1.6.10.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/dynasonics-isonic-4000-flow-meter-software/",
        "id": "455",
        "productName": null,
        "languages": [
          "English"
        ],
        "brand": "Dynasonics",
        "brands": [
          "Dynasonics"
        ],
        "downloadType": "Software",
        "documentName": "Dynaconics Flow Meter Tool",
        "releaseNotes": null
      },
      {
        "eyebrow": "Research Control Valve (RCV)",
        "name": "RCV SEVA 100 EtherNet/IP Driver",
        "details": "Software | Updated August 19, 2020 | 3 KB",
        "downloadUrl": "https://badgermeter.widen.net/content/riwznioshg/original/RCV%20SEVA%20100%20EtherNetIP%20Driver.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/rcv-seva-100-ethernet-ip-driver/",
        "id": "444",
        "productName": null,
        "languages": [
          "English"
        ],
        "brand": "Research Control Valve (RCV)",
        "brands": [
          "Research Control Valve (RCV)"
        ],
        "downloadType": "Software",
        "documentName": "RCV SEVA 100 EtherNet/IP Driver",
        "releaseNotes": null
      },
      {
        "eyebrow": "Coriolis",
        "name": "Coriolis RCT Calc Selection Tool",
        "details": "Software | Updated August 19, 2020 | 21.73 MB",
        "downloadUrl": "https://badgermeter.widen.net/content/ryl0fcae6v/original/Coriolis%20RCT%20Calc%20Selection%20Tool.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/sizing-and-selection-tools/coriolis-rctcalc-selection-tool/",
        "id": "460",
        "productName": null,
        "languages": [
          "English"
        ],
        "brand": "Coriolis",
        "brands": [
          "Coriolis"
        ],
        "downloadType": "Software",
        "documentName": "Coriolis RCT Calc Selection Tool",
        "releaseNotes": null
      },
      {
        "eyebrow": "ModMAG",
        "name": "ModMAG M5000 Firmware",
        "details": "Firmware | Version v2.0.25 | Updated August 19, 2020 | 53 KB",
        "downloadUrl": "https://badgermeter.widen.net/content/767ksclvco/original/ModMAG%20M5000%20Firmware-v2.0.25.zip?download=true&x.app=api",
        "downloadHref": "#downloadhref",
        "viewDetailsUrl": "/software-firmware/modmag-m5000-firmware/",
        "id": "442",
        "productName": "M5000",
        "languages": [
          "English"
        ],
        "brand": "ModMAG",
        "brands": [
          "ModMAG"
        ],
        "downloadType": "Firmware",
        "documentName": "ModMAG M5000 Firmware",
        "releaseNotes": null
      }
    ],
    "savedItemsCount": 0,
    "totalResults": 60,
    "releaseNotesLabel": "release notes label"
  },
  "documentation": {
    "results": [
      {
        "eyebrow": "APPLICATION DATA SHEET",
        "name": "LM_LM-OGA-OGTAER_ZUL_MID_01_2012",
        "details": "ModMAG M-Series M2000",
        "language": "English",
        "url": "https://badgermeter.widen.net/content/fjcdopcl3n/original/IOG-PS-00137-EN_Industrial%20Oval%20Gear%20Inline%20and%20Flanged%20Meters%20and%20Register%20Parts.pdf?download=true&x.app=api",
        "id": "35",
        "documentId": "abc-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Electromagnetic flow meter user manual",
        "details": "ModMAG M-Series M2000, test1, test2,test3, test4, test5",
        "language": "French",
        "url": "https://badgermeter.widen.net/content/hiv7vd69uo/original/TTM-SS-03125-EN_Dynasonics TFX-5000 Flow Meter Specifications.docx?download=true",
        "id": "36",
        "documentId": "def-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "37",
        "documentId": "ghi-000-0000-000"
      },
      {
        "eyebrow": "APPLICATION DATA SHEET",
        "name": "Electromagnetic flow meter data sheet",
        "details": "ModMAG M-Series M2000, test, test, test, test, test",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "38",
        "documentId": "jkl-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Electromagnetic flow meter user manual",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "39",
        "documentId": "mno-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "40",
        "documentId": "prq-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "41",
        "documentId": "abc-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "42",
        "documentId": "abc-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "43",
        "documentId": "abc-000-0000-000"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "44",
        "documentId": "abc-000-0000-000"
      }
    ],
    "totalResults": 88
  },
  "documentationTest": {
    "results": [
      {
        "eyebrow": "APPLICATION DATA SHEET test",
        "name": "Electromagnetic flow meter data sheet",
        "details": "ModMAG M-Series M2000",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "350"
      },
      {
        "eyebrow": "MANUALS & GUIDES test",
        "name": "Electromagnetic flow meter user manual",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "360"
      },
      {
        "eyebrow": "MANUALS & GUIDES",
        "name": "Test item 3",
        "details": "ModMAG M-Series M2000",
        "language": "French",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "370"
      }
    ],
    "totalResults": 11
  },
  "legal": {
    "results": [
      {
        "eyebrow": "Purchase terms",
        "name": "Purchase order - general terms and conditions",
        "details": "North America, test2, test3, test4, test5",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "40"
      },
      {
        "eyebrow": "Sales terms",
        "name": "Badger Meter sales terms and onditions",
        "details": "North America, test1, test2",
        "language": "English",
        "url": "https://widen.badgermeter.com/damstuff/document.docx",
        "id": "70"
      }
    ],
    "totalResults": 67
  },
  "validateIds": {
    "success": "true",
    "results": {
      "invalidIds": [
        10,
        5,
        110,
        2
      ],
      "documentIds": [
        35,
        41
      ],
      "softwareIds": [
        74
      ],
      "productIds": [
        11,
        20,
        35,
        8
      ],
      "articleIds": []
    }
  },
  "beaconrefs": {
    "success": true,
    "content": {
      "chat_doc_id": "25cf117fef15421e813739ff6204cedb",
      "prompt_intent": "GENERAL_QUESTION",
      "response": "The following references were identified in the search:",
      "sources": [
        {
          "category": "BADGER_METER_SITE_DAM",
          "date_created": "2024-06-27T15:21:42+00:00",
          "date_published": "2024-06-27T15:21:42+00:00",
          "date_updated": "2024-06-27T15:21:42+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/onii5cdw7m/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/onii5cdw7m/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/dam/9ac7d962d4e588bd71b39fd5a43125a7e3530d3d6e8fad493371da3598d55c67.png",
          "source_title": "RTS-DS-00320-EN\\_Recordall Turbo Series Meters Models 160, 200, 450, 1000, 2000, 3500, 5500, 6200",
          "source_url": "https://badgermeter.widen.net/content/onii5cdw7m/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE",
          "date_created": "2024-06-27T15:22:07+00:00",
          "date_published": "2024-06-27T15:22:07+00:00",
          "date_updated": "2024-06-27T15:22:07+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/vodetxkyxh/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/vodetxkyxh/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/cms/24a270a2597726f4dca7107a3c0b53c218ff0fc75084dc6e15133198de631fa4.png",
          "source_title": "",
          "source_url": "https://badgermeter.widen.net/content/vodetxkyxh/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE",
          "date_created": "2024-06-27T15:23:35+00:00",
          "date_published": "2024-06-27T15:23:35+00:00",
          "date_updated": "2024-06-27T15:23:35+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/aielwqtffe/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/aielwqtffe/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/cms/a236ceeceb97862294623e29a7498a669837e7d16a85b9209edfa2b00b46deb4.png",
          "source_title": "",
          "source_url": "https://badgermeter.widen.net/content/aielwqtffe/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE_DAM",
          "date_created": "2024-06-27T15:21:41+00:00",
          "date_published": "2024-06-27T15:21:41+00:00",
          "date_updated": "2024-06-27T15:21:41+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/dam/35e78c89f1f25e39636fd8de98288743bc9d7a8c73ffe13484bff3c3500091b7.png",
          "source_title": "ORION Endpoint Utility 2.7.X for Trimble Ranger 3 Manual (ORI-UM-00802-EN).pdf",
          "source_url": "https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE_DAM",
          "date_created": "2024-06-27T15:21:41+00:00",
          "date_published": "2024-06-27T15:21:41+00:00",
          "date_updated": "2024-06-27T15:21:41+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/dam/35e78c89f1f25e39636fd8de98288743bc9d7a8c73ffe13484bff3c3500091b7.png",
          "source_title": "ORION Endpoint Utility 2.7.X for Trimble Ranger 3 Manual (ORI-UM-00802-EN).pdf",
          "source_url": "https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api"
        }
      ],
      "status": "GENERATE_ANSWER_END",
      "took_secs": 0.53,
      "anonymous_id": "986f7fb25ef94d43a36321068d2e01b4"
    }
  },
  "beacondocs": {
    "success": true,
    "content": {
      "chat_doc_id": "0868bee1b1e24fcfbe4575b81a2e9dfe",
      "confidence_level": null,
      "disclaimer": "This information was generated by an AI system and should not be solely relied upon for decision-making. Always verify information with credible sources and consult with relevant experts before taking any action based on AI-generated content.",
      "preferred_language": "en",
      "prompt_intent": "GENERAL_QUESTION",
      "related_questions": [
        "What are the steps to clear a tamper condition on an endpoint?",
        "How can i troubleshoot common issues related to endpoint tampering?"
      ],
      "response": "The ModMAG documentation provides detailed information on the installation, operation, and maintenance of Badger Meter's ModMAG flow meters. Here are some key points extracted from the documentation:\n\n1. **Installation Requirements**:\n   - Temperature sensors must be connected to specific clamps: the inlet flow temperature sensor to clamps 5 and 6, and the outlet flow temperature sensor to clamps 7 and 8. The color of the wires does not matter, but connections must be tight [**2**].\n   - The pulse output of the flow meter must match the calculator input pulse value. For flow meters with open collector connections, ensure the polarity is correct [**2**].\n\n2. **Flow Meter Specifications**:\n   - Flow meters should comply with Class OA (reed contact) and Class OC (open collector) standards according to EN 1434-2: 2015. The maximum input frequency is 10 Hz, with a pulse length of at least 25 ms and a pulse pause of at least 50 ms [**2**].\n\n3. **Operation Guidelines**:\n   - Before starting operation, ensure that the flow meter is the correct size, the directional arrow matches the flow direction, and there are no leaks. Additionally, check that the heating/cooling system is clear of clogs [**2**].\n\n4. **Maintenance Procedures**:\n   - Regular cleaning of the flow tube and electrodes may be necessary, depending on the properties of the process fluid. Use isopropyl alcohol or clean water for cleaning, ensuring compatibility with the measured fluid [**4**].\n   - Fuse replacement should only be performed by authorized personnel, and the same type and rating of fuses must be used [**4**].\n\n5. **Technical Support**:\n   - If issues arise with the meter, it is recommended to contact Badger Meter's technical support for assistance, especially if a problem appears to originate from the printed circuit board (PCB) [**4**].\n\nFor more detailed information, including specific installation diagrams and technical specifications, you can refer to the official Badger Meter documentation available on their website [**1**].\n\nIf you have specific aspects of the ModMAG documentation you would like to explore further, please let me know!\n\n",
      "sources": [
        {
          "category": "BADGER_METER_SITE_DAM",
          "date_created": "2024-06-27T15:21:42+00:00",
          "date_published": "2024-06-27T15:21:42+00:00",
          "date_updated": "2024-06-27T15:21:42+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/onii5cdw7m/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/onii5cdw7m/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/dam/9ac7d962d4e588bd71b39fd5a43125a7e3530d3d6e8fad493371da3598d55c67.png",
          "source_title": "ORION Field Application 4.3.0 for Trimble Ranger 3 with ReadCenter Manual (ORI-UM-00185-EN).pdf",
          "source_url": "https://badgermeter.widen.net/content/onii5cdw7m/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE",
          "date_created": "2024-06-27T15:22:07+00:00",
          "date_published": "2024-06-27T15:22:07+00:00",
          "date_updated": "2024-06-27T15:22:07+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/vodetxkyxh/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/vodetxkyxh/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/cms/24a270a2597726f4dca7107a3c0b53c218ff0fc75084dc6e15133198de631fa4.png",
          "source_title": "",
          "source_url": "https://badgermeter.widen.net/content/vodetxkyxh/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE",
          "date_created": "2024-06-27T15:23:35+00:00",
          "date_published": "2024-06-27T15:23:35+00:00",
          "date_updated": "2024-06-27T15:23:35+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/aielwqtffe/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/aielwqtffe/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/cms/a236ceeceb97862294623e29a7498a669837e7d16a85b9209edfa2b00b46deb4.png",
          "source_title": "",
          "source_url": "https://badgermeter.widen.net/content/aielwqtffe/original?download=false&x.app=api"
        },
        {
          "category": "BADGER_METER_SITE_DAM",
          "date_created": "2024-06-27T15:21:41+00:00",
          "date_published": "2024-06-27T15:21:41+00:00",
          "date_updated": "2024-06-27T15:21:41+00:00",
          "source": "KNN",
          "source_language": "en",
          "source_page_number": null,
          "source_summary": "[Read more...](https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api)",
          "source_summary_full": "[Read more...](https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api)",
          "source_thumbnail": "https://aquaflo.beaconama-staging.net/v_6_4/thumbnails/dam/35e78c89f1f25e39636fd8de98288743bc9d7a8c73ffe13484bff3c3500091b7.png",
          "source_title": "ORION Endpoint Utility 2.7.X for Trimble Ranger 3 Manual (ORI-UM-00802-EN).pdf",
          "source_url": "https://badgermeter.widen.net/content/zjkj72tjs2/original?download=false&x.app=api"
        }
      ],
      "status": "GENERATE_ANSWER_END",
      "took_secs": 6.13,
      "anonymous_id": "c24dbe56476a4bdc9277f3cf04f11357"
    }
  },
  "beaconfeedback": {
    "success": true
  }
}